import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { useForm } from "antd/es/form/Form";
import { UploadOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";

const { Title, Text } = Typography;

const FormEpisode = (props) => {
  const { onFinish, initialValues, title, isLoading, errorMsg, form } = props;

  const navigate = useNavigate();
  const { state } = useLocation();
  const { serie, seasons } = state;

  return (
    <>
      <Row align="middle">
        <Col span={1}>
          <Button
            shape="circle"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          />
        </Col>
        <Col span={10}>
          <Title style={{ margin: 0, marginLeft: 10 }} level={3}>
            {title}
          </Title>
        </Col>
      </Row>

      <Title
        style={{ margin: 0, marginTop: 30 }}
        level={4}
      >{`Série ${serie.name}`}</Title>
      {initialValues.epName ? (
        <Title
          style={{ margin: 0, marginTop: 5, marginBottom: 30 }}
          level={5}
        >{`Épisode ${initialValues.epName}`}</Title>
      ) : null}
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="Saison"
              name="saison"
              rules={[{ required: true, message: "Choisir une saison" }]}
            >
              <Select
                options={seasons.map((s) => {
                  return { label: `Saison ${s.number}`, value: s.id };
                })}
                onSelect={(v) => {
                  const tmp = seasons.find((s) => {
                    return s.id === v;
                  });
                  if (tmp) {
                    console.log("Set tmp :", tmp.Episodes.length + 1, tmp);
                    // setSeasonChoose(tmp);
                    form.setFieldsValue({
                      epNumber: tmp.Episodes.length + 1,
                      illustrator: tmp.illustrator,
                      author: tmp.author,
                    });
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Nom de l'épisode"
              name="epName"
              rules={[{ required: true, message: "Choisir un nom d'épisode" }]}
            >
              <Input placeholder="Lulu en bivouac ⛺️" />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item label="Statut de l'épisode" name="epState">
              <Select
                options={[
                  { value: "free", label: "Gratuit" },
                  { value: "subscribed", label: "Abonné" },
                  { value: "admin", label: "Administrateur" },
                  { value: "unavailable", label: "Indisponible" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Numéro d'épisode"
              name="epNumber"
              rules={[{ required: true, message: "Choisir un nombre valide" }]}
            >
              <InputNumber min={1} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={9}>
            <Form.Item
              label="Auteur"
              name="author"
              rules={[{ required: true, message: "Auteur nécessaire" }]}
            >
              <Input placeholder="Anne-Marie Desplat Duc" />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              label="Illustrateur"
              name="illustrator"
              rules={[{ required: true, message: "Illustrateur nécessaire" }]}
            >
              <Input placeholder="Picasso" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Couverture de l'épisode" name="epCover">
              <Dragger
                maxCount={1}
                // onRemove={onRemove}
                beforeUpload={() => false}
              >
                <p className="ant-upload-drag-icon">
                  <UploadOutlined />
                </p>
                <p className="ant-upload-text">
                  Cliquer ou lâcher une couverture ici
                </p>
              </Dragger>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item wrapperCol={{ span: 16 }}>
          <Button loading={isLoading} type="primary" htmlType="submit">
            Enregistrer
          </Button>
        </Form.Item>
        <Text type="danger">{errorMsg}</Text>
      </Form>
    </>
  );
};

export default FormEpisode;
